<template>
    <div class="front-index" style="height: 100%;">
        <!-- 左侧菜单栏 -->
        <frontMenu></frontMenu>
        
        <!-- 右侧内容主体 -->
        <div class="page-right">
            <div class="page-right-top">
                <!-- 信息提示 -->
                <readInfo class="align"></readInfo>
                <!-- 头像 and 菜单 -->
                <el-dropdown menu-align="start">
                    <!-- 头像 -->
                    <z-lazyImg id="img" class="user-photo-nav" :src='userInfo.userLogo'></z-lazyImg>
                    
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if='code(2000)'>
                            <div @click="goSystem">系统管理</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div @click="changeImg">上传头像</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div @click="logout">退出登录</div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!-- <div class="right-top-search" v-if="showTopBarItem[5]">
                    <label class="icon-search"></label>
                    <input @keyup.enter="goSearch" v-model="keyword" type="text" autocomplete="off"
                           :placeholder="searchTip">
                </div> -->
            </div>

            <div class="main">
                <!-- <transition name="frontpage"> -->
                    <router-view></router-view>
                <!-- </transition> -->
            </div>
        </div>

        <transition name="fade">
            <upAvatar :img="userInfo.userLogo" v-show="openAvatar"></upAvatar>
        </transition>

    </div>
</template>

<script>
    import {mapState,mapGetters} from 'vuex'
    
    import frontMenu from './frontMenu.vue'
    import upAvatar from './upAvatar.vue'

    // ****信息组件
    import readInfo from 'src/components/info/read-info.vue';


    export default {
        components: {
            frontMenu,
            upAvatar,
            readInfo,
        },
        data () {
            return {
                openAvatar:false,
            }
        },
        computed: {
            ...mapState(['userInfo']),
            ...mapGetters(['codeList']),
            user_easy(){
                return {
                    id:this.userInfo.id,
                    company_id:this.userInfo.companyId,
                    bu_id:this.userInfo.buId,
                    real_name:this.userInfo.realName,
                    type:'user',
                }
            },
        },
        mounted(){
            this.$func.getLink(this.user_easy);  //连接websocket 
            this.$func.getCurrencyList(true);   //获取快币列表
        },

        methods: {
            // ******常规功能
            logout() {  //退出登录
                this.$http.post('api/user/logout').then(res => {
                    if (res.status == 200) {
                        this.$func.logout();
                        console.log(`跳链`)
                        this.$router.push({name: 'login'});
                    }
                });
            },
            goSystem() {
                this.$router.push({name: 'backhome'});
            },
            changeImg() {
                this.openAvatar = true;
            },
            code(val){  //验证权限
                return this.codeList.some(code=>code==val);
            },
        },

    }
</script>

<style scoped lang="less">
    @import "~src/assets/less/var.less";

    .main{
        box-sizing: border-box;
        padding:@front_padd;
        height:calc(~"100% - @{front_head_h}");
        overflow: hidden;
    }

    .front-index{
        .clear();
    }

    .page-right{
        width:calc(~"100% - @{front_side_w}");
        height:100%;
        position:relative;
        float: left;
    }

    .page-right-top{
        height: @front_head_h;
        background: white;
        font-size: 0;
        position: relative;
        .align{  //信息提示位置调整
            position: absolute;
            right:75px;
        }
    }
    .page-right-top i{position: absolute;right: 0;top:0;display: inline-block;margin-top:15px;height: 30px;border-left: 1px solid #808080}
    .user-photo-nav{width: 36px;height: 36px;cursor: pointer}

    // *********************

    #img {
        position: relative;
    }

    .el-dropdown {
        float: right;
        margin: 12px 37px 0 20px
    }

    .el-dropdown-menu {
        padding: 0;
        min-width: 90px;
        width: 90px;
        text-align: center;
        box-shadow: 0px 0px 4px 0px rgba(127, 127, 127, 0.50);
        font-family: SourceHanSansCN-Normal;
        font-size: 12px;
        color: #7f7f7f;
        letter-spacing: 1.33px;
        margin-right: 20px;
    }

    .user-photo-nav {
        border-radius: 50%;
        border:1px solid #ccc;  
        /*box-sizing: border-box;*/
        /*padding: 4px;*/
        /*box-shadow: 0 0 4px 1px #8a8a8a;*/
    }

    .el-dropdown-menu__item {
        height: 24px;
        line-height: 24px;
    }

    .el-dropdown-menu__item > div {
        height: 24px;
        line-height: 24px;
    }
</style>



// WEBPACK FOOTER //
// Index.vue?ecad7894